import React from "react";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";

import { getAuthUser } from "../../redux";
import { CommentSection } from "../../components/Comments";
import { useUserHookFormList } from "../../components/UsersHookFormSelect/useUserHookFormList";

const CustomerCommentsContainer = ({ user }) => {
  const { id } = useParams();
  const { users } = useUserHookFormList();

  return (
    <Stack
      height="100%"
      overflow="auto"
      sx={{
        "::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <CommentSection
        resourceType="customer"
        resourceId={Number(id)}
        currentUserId={user?.id}
        users={users}
      />
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  user: getAuthUser(state),
});

export const CustomerComments = connect(mapStateToProps)(
  CustomerCommentsContainer,
);
export default CustomerComments;
